import * as ContractReviewStore from '../../../../redux/middleware/ContractReview.Middleware';
import * as ContractAddendumStore from '../../../../redux/middleware/ContractAddendum.Middleware';
import * as ContractStageStore from '../../../../redux/middleware/ContractStageMiddleware';
import * as ContractConceptStore from '../../../../redux/middleware/ContractConceptMiddleware';
import { AppState } from '../../../../redux/reducers';
import { ContractAddendum } from '../../../../models/Entities/Contracts/ContractAddendum';
import { ContractIAImportProcess } from '../../../../models/Entities/Contracts/ContractIAImportProcess';
import { ContractReview } from '../../../../models/Entities/Contracts/ContractReview';
import { ErrorType } from '../../../../models/HttpError';
import { ContractParametrizationEntry } from '../../../../redux/states/ContractReview.States';

// Estado de las revisiones con IA dentro del widget de importación (US2, US7, US8).

export interface IProps {
  contractId: number;
  addendum?: ContractAddendum;
}

interface ConnectedProps {
  reviews: ContractReview[];
  isLoading: boolean;
  error?: ErrorType;
  addendums: ContractAddendum[];
  lastImportProcess: ContractIAImportProcess | null;
  parametrization?: ContractParametrizationEntry;
}

interface DispatchProps {
  GetContractReviews: typeof ContractReviewStore.actionCreators.GetContractReviews;
  GetContractParametrizationStatus: typeof ContractReviewStore.actionCreators.GetContractParametrizationStatus;
  GetContractAddendumsByContractId: typeof ContractAddendumStore.actionCreators.GetContractAddendumsByContractId;
  GetAllContractStagesByAddendumId: typeof ContractStageStore.actionCreators.GetAllContractStagesByAddendumId;
  GetAllContractsConceptByAddendum: typeof ContractConceptStore.actionCreators.GetAllContractsConceptByAddendum;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, own: IProps): ConnectedProps => {
  const entry = state.ContractReview?.listByContract?.[own.contractId];
  return {
    reviews: entry?.items ?? [],
    isLoading: !!entry?.isLoading,
    error: entry?.error,
    addendums: state.Contract?.list?.find(c => c.id === own.contractId)?.addendums ?? [],
    lastImportProcess: state.ContractIAImport?.lastProcess ?? null,
    parametrization: state.ContractReview?.parametrizationByContract?.[own.contractId]
  };
};

export const mapDispatchToProps = {
  GetContractReviews: ContractReviewStore.actionCreators.GetContractReviews,
  GetContractParametrizationStatus: ContractReviewStore.actionCreators.GetContractParametrizationStatus,
  GetContractAddendumsByContractId: ContractAddendumStore.actionCreators.GetContractAddendumsByContractId,
  GetAllContractStagesByAddendumId: ContractStageStore.actionCreators.GetAllContractStagesByAddendumId,
  GetAllContractsConceptByAddendum: ContractConceptStore.actionCreators.GetAllContractsConceptByAddendum
};

/**
 * La revisión de la primera importación se aplica sola (Contracts `AutoApplyAfterImport`). Si quedó Completed sin
 * ningún hallazgo aceptado es que no traía cambios aplicables (sólo avisos y buenas prácticas): se muestra "sin cambios
 * para aplicar" en lugar de dejar la duda de si falta aplicarla. Si la aplicación automática hubiera fallado, habría
 * hallazgos aceptados.
 */
export const isAfterImportWithoutChanges = (review: Pick<ContractReview, 'trigger' | 'status' | 'acceptedCount'>): boolean =>
  review.trigger === 'AfterImport' && review.status === 'Completed' && review.acceptedCount === 0;
